export default function initFooter() {
  Alpine.data('footer', () => ({
    openDropdownKey: '',
    toggleMenuSectionOpen(key: string) {
      if (key) {
        this.openDropdownKey = this.openDropdownKey === key ? '' : key;
      }
    },
    isMenuSectionOpen(key: string) {
      return this.openDropdownKey === key;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }));
}
